import type {LegacyFileBet} from "@atg-horse-shared/horse-state";

export enum FileBetActionType {
    REQUEST_FILE_BETS = "REQUEST_FILE_BETS",
    RECEIVED_FILE_BETS = "RECEIVED_FILE_BETS",
    ERROR_FILE_BETS = "ERROR_FILE_BETS",
}

export type requestFileBetAction = {
    type: FileBetActionType.REQUEST_FILE_BETS;
    payload: {
        groupBetId: string;
        placedAt: string;
    };
};

export type receiveFileBetAction = {
    type: FileBetActionType.RECEIVED_FILE_BETS;
    payload: Array<LegacyFileBet>;
};

export type errorFileBetAction = {
    type: FileBetActionType.ERROR_FILE_BETS;
    payload: boolean;
};
